import { DATE_FE_FORMAT, TIME_FORMAT } from '@/constants';
import { ForwardRefExoticComponent, forwardRef } from 'react';

import { Datetime } from '@/utils';
import { LostAndFoundIssueWithCache } from '@/models/gen/graphql';
import SimpleTableCell from '@/components/SimpleTable/SimpleTableCell';
import SimpleTableRow from '@/components/SimpleTable/SimpleTableRow';
import { useLostAndFoundHistoryDrawer } from '@/features/LostAndFoundHistory/components/LostAndFoundHistoryDrawer';
import { useProvider } from '@/common/Provider';
import { returnStatusDisplay } from '@/features/LostAndFoundHistory/utils/helpers';

const LostAndFoundFormHistoryTableRow = ({ id }: { id: string }, ref: ForwardRefExoticComponent<HTMLDivElement>): JSX.Element => {
  const [[lostAndFound], , { onEditLostAndFound }] = useProvider<
    { data: Map<string, LostAndFoundIssueWithCache>; driverFirstName: string; driverLastName: string; vehicleTrackingId: string },
    [LostAndFoundIssueWithCache, string, string, string],
    { onEditLostAndFound: (accident: LostAndFoundIssueWithCache) => void }
  >(({ data: lostAndFound, driverFirstName, driverLastName, vehicleTrackingId }) => [
    lostAndFound.get(id) || ({} as LostAndFoundIssueWithCache),
    driverFirstName,
    driverLastName,
    vehicleTrackingId,
  ]);
  const [state, setLostAndFoundHistoryDrawer] = useLostAndFoundHistoryDrawer(({ state, setState }) => [state, setState]);

  const onEdit = (): void => {
    if (onEditLostAndFound) return onEditLostAndFound(lostAndFound);
    setLostAndFoundHistoryDrawer((current) => ({
      ...current,
      show: true,
      data: lostAndFound,
    }));
  };

  return (
    <SimpleTableRow id={id} onDoubleClick={onEdit} ref={ref} visible>
      <SimpleTableCell name="LOST_AND_FOUND" className="w-md-grow">
        <span>
          {[lostAndFound.driverFirstName, lostAndFound.driverLastName].join(' ')} - #{lostAndFound.vehicleTrackingId}
        </span>
        <span>{[lostAndFound.itemLost, returnStatusDisplay(lostAndFound.returnStatus)].filter(Boolean).join(' - ')}</span>
      </SimpleTableCell>
      <SimpleTableCell name="CREATED_AT">
        <span>{new Datetime(lostAndFound.createdAt).format(DATE_FE_FORMAT)}</span>
        <span>{new Datetime(lostAndFound.createdAt).format(TIME_FORMAT)}</span>
      </SimpleTableCell>
    </SimpleTableRow>
  );
};

export default forwardRef(LostAndFoundFormHistoryTableRow);
